import { QuarterlyAveragesCard } from "./QuarterlyAveragesCard";
import { StateSpendChartCard } from "./StateSpendChartCard";
import { TwoPanelChartCard } from "./TwoPanelChartCard";

export function ChartsGrid({ charts, isLoading }) {
  return (
    <div className="min-w-0 space-y-4">
      <TwoPanelChartCard chart={charts.difotByPeriod} isLoading={isLoading} fallbackTitle="Delivery Performance" rulesKey="deliveryPerformance" />
      <TwoPanelChartCard chart={charts.monthlyFreightSpend} isLoading={isLoading} fallbackTitle="Freight Spend $ Trend" rulesKey="freightSpendTrend" />
      <QuarterlyAveragesCard chart={charts.quarterlyAverages} isLoading={isLoading} />
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <StateSpendChartCard chart={charts.freightSpendByFromState} isLoading={isLoading} fallbackTitle="Freight Spend by From State — Current Quarter" />
        <StateSpendChartCard chart={charts.freightSpendByToState} isLoading={isLoading} fallbackTitle="Freight Spend by To State — Current Quarter" />
      </div>
    </div>
  );
}
